import dynamic from 'next/dynamic';
import { type Dispatch, type SetStateAction } from 'react';

import { ENTITY_TYPE } from '@vimeo/lead-capture-widgets/exports/constants';

const LeadCaptureView = dynamic(
  async () => {
    const { LeadCaptureView } = await import('@vimeo/lead-capture/exports/viewer');
    return LeadCaptureView;
  },
  {
    ssr: false,
  },
);

export const LeadCapturePage = ({
  albumId,
  setLeadUuid,
}: {
  albumId: string;
  setLeadUuid: Dispatch<SetStateAction<string | null>>;
}) => {
  return (
    <LeadCaptureView
      entityId={albumId}
      type={ENTITY_TYPE.SHOWCASE}
      setLeadUuid={setLeadUuid}
      previewSize={{ height: '100vh', width: '100%' }}
    />
  );
};
